import { partial } from "filesize";
import { i18next } from "./slice";

export const toHumanSize = partial({ 
    standard: "jedec", 
    locale: i18next.language,
    output: "string"
});
